module.exports = __webpack_public_path__ + "img/img-7.1a9736a8.png";